// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-zfcat{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-info-__slug-indexstyleGrid-grid-goxyh{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-briai{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-eitah{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-bxofm{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-bzajs{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-ehxbl{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-brgsu{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-zfcat",
	"grid": "pages-info-__slug-indexstyleGrid-grid-goxyh",
	"col6": "pages-info-__slug-indexstyleGrid-col6-briai",
	"col3": "pages-info-__slug-indexstyleGrid-col3-eitah",
	"col4": "pages-info-__slug-indexstyleGrid-col4-bxofm",
	"col9": "pages-info-__slug-indexstyleGrid-col9-bzajs",
	"col12": "pages-info-__slug-indexstyleGrid-col12-ehxbl",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-brgsu"
};
module.exports = ___CSS_LOADER_EXPORT___;
